import {
  Controller,
  FieldValues,
  FieldPath,
  useFormContext,
  FieldError,
} from "react-hook-form";

import Autocomplete from "./Autocomplete";
import {
  AutocompleteHookFormProps,
  AutocompleteProps,
  AutocompleteValue,
} from "./Autocomplete.types";

const AutocompleteHookForm = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
  Value extends TFieldValues[TName] = TFieldValues[TName]
>({
  name,
  defaultValue,
  rules,
  shouldUnregister,
  setPropsWithFormState,
  onChange: onChangForm,
  ...innerProps
}: AutocompleteHookFormProps<TFieldValues, TName, Value>) => {
  const { control } = useFormContext<TFieldValues>();
  return (
    <Controller
      name={name}
      defaultValue={defaultValue}
      rules={rules}
      shouldUnregister={shouldUnregister}
      control={control}
      render={(formState) => {
        const {
          field: { disabled, ref, onChange, ...innerField },
          formState: { errors },
        } = formState;
        const error = errors[name] as unknown as {
          label: FieldError;
          value: FieldError;
        };
        const errorMsg =
          (error as unknown as FieldError)?.message ?? error?.value?.message;
        const helperText =
          typeof errorMsg === "string" ? errorMsg : innerProps?.helperText;
        return (
          <Autocomplete
            {...innerProps}
            {...innerField}
            inputRef={ref}
            error={!!error}
            helperText={helperText}
            disabled={
              typeof disabled === "boolean" ? disabled : innerProps.disabled
            }
            onChange={(e) => {
              if (onChangForm) onChangForm(e);
              onChange(e) as AutocompleteProps<
                AutocompleteValue<Value>
              >["onChange"];
            }}
            {...(setPropsWithFormState?.(formState) ?? {})}
          />
        );
      }}
    />
  );
};

export default AutocompleteHookForm;
